import useOrderListProps from "../selectors/useOrderListProps";
import OrderList from "../components/orderList";

export default function OrdersPage() {
	const viewProps = useOrderListProps();
	return OrderList(viewProps);
}
